<template>
  <div class="bg-formgray mt-32 xl:mt-150px">
    <div class="container mx-auto py-20">
      <div class="flex gap-4 flex-wrap sm:flex-nowrap">
        <div class="ml-4">
          <qrcode-vue :value="url" :size="size" level="H" :margin="5" class="w-full h-fit"/>
        </div>
        <div class="px-5 mt-8 md:mt-0 flex flex-col ">
          <MARSTitle margin-bottom="mb-0">{{ $t('tryit.title') }}</MARSTitle>
          <p class="pt-6">{{ $t('tryit.cta') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  export default {
    name: 'Tryit',
    inheritAttrs: false,
    customOptions: {}
  }
</script>
<script setup lang="ts">
import QrcodeVue from 'qrcode.vue'
import MARSTitle from '@/components/MARSTitle.vue'

const route = useRoute()
const size = computed( () => {
  return 300
})
const url = computed( () => {
  if(process.client) {
    return document.location.href
  }
  return process.env.BASE_URL + route.fullPath
})
</script>

<style scoped>
</style>
